import { html, toString } from './html.js';
import { me } from '../services/me.js';
import { space } from '../services/space.js';

/**
 * Barra de abas flutuante (vidro no iPhone, barra tonal + FAB no Android), um conjunto por espaço:
 *   Pessoal  Início · Garagem · Conta        + Buscar (círculo à parte)
 *   Empresa  Painel · Veículos · Empresa · Conta + Receber veículo (círculo laranja)
 * Cada aba é uma tela raiz: trocar de aba não empilha histórico (navegação "root").
 * "Conta" é a mesma tela nos dois espaços: a barra segue o espaço atual.
 *
 *   <ion-footer class="tabbar-footer"><tc-tabbar active="home"></tc-tabbar></ion-footer>
 *
 * O espaço depende do perfil (me), que pode chegar depois: a tela chama refresh() no onEnter.
 */
const PERSONAL = {
  tabs: [
    { key: 'home', path: '/home', label: 'Início', icon: 'home-outline' },
    { key: 'garage', path: '/garagem', label: 'Garagem', icon: 'tc-garage' },
    { key: 'profile', path: '/profile', label: 'Conta', icon: 'person-circle-outline' },
  ],
  action: { key: 'showcase', path: '/oficinas', label: 'Buscar empresas', icon: 'search-outline', root: true },
};
const BUSINESS = {
  tabs: [
    { key: 'panel', path: '/workshop', label: 'Painel', icon: 'grid-outline' },
    { key: 'vehicles', path: '/oficina/veiculos', label: 'Veículos', icon: 'tc-truck' },
    { key: 'company', path: '/oficina/empresa', label: 'Empresa', icon: 'storefront-outline' },
    { key: 'profile', path: '/profile', label: 'Conta', icon: 'person-circle-outline' },
  ],
  action: { key: 'receive', path: '/autorizacao', label: 'Receber veículo', icon: 'tc-qr', root: false },
};

class TabBar extends HTMLElement {
  connectedCallback() {
    this.refresh();
    // montada junto com a tela (innerHTML do template), os ion-icon às vezes não renderizam: remonta no quadro seguinte
    requestAnimationFrame(() => this.refresh());
    if (!this._bound) {
      this._bound = true;
      this.addEventListener('click', (e) => {
        const b = e.target.closest('[data-tab]');
        if (!b || b.getAttribute('aria-current') === 'page') return;
        document.querySelector('ion-router').push(b.dataset.tab, b.dataset.root === 'false' ? 'forward' : 'root');
      });
    }
  }

  refresh() {
    const active = this.getAttribute('active');
    void me.current; // o espaço depende do perfil carregado
    // abrir uma aba de um espaço é estar nele (ex.: tocar numa notificação de revisão leva ao Pessoal)
    if (PERSONAL.tabs.some((t) => t.key === active && t.key !== 'profile') || active === PERSONAL.action.key) {
      if (space.current !== 'personal') space.set('personal');
    } else if (BUSINESS.tabs.some((t) => t.key === active && t.key !== 'profile') && space.available && space.current !== 'business') {
      space.set('business');
    }
    const biz = space.current === 'business';
    const set = biz ? BUSINESS : PERSONAL;
    const a = set.action;
    this.innerHTML = toString(html`
      <div class="glassbar ${biz ? 'biz' : ''}">
        <nav class="tabbar" aria-label="Navegação principal">
          ${set.tabs.map(
            (t) => html`
              <button type="button" class="tab ${t.key === active ? 'on' : ''}" data-tab="${t.path}" ${t.key === active ? html`aria-current="page"` : ''}>
                <span class="tab-dot"><ion-icon name="${t.icon}" aria-hidden="true"></ion-icon></span>
                <span class="tab-label">${t.label}</span>
              </button>`,
          )}
        </nav>
        <button type="button" class="glass-action ${biz ? 'biz' : ''} ${a.key === active ? 'on' : ''}" data-tab="${a.path}" data-root="${a.root ? 'true' : 'false'}" aria-label="${a.label}" ${a.key === active ? html`aria-current="page"` : ''}>
          <ion-icon name="${a.icon}" aria-hidden="true"></ion-icon>
        </button>
      </div>`);
  }
}

customElements.define('tc-tabbar', TabBar);

/** Rodapé com a barra de abas, para o template das telas raiz (o ion-content delas leva fullscreen + class="has-tabbar"). */
export const tabbarFooter = (active) => html`<ion-footer class="tabbar-footer"><tc-tabbar active="${active}"></tc-tabbar></ion-footer>`;
